goog.provide("shadow.js.shim.module$src$svg$objects$calendar_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$calendar_svg");
shadow.js.shim.module$src$svg$objects$calendar_svg = shadow.js.nativeProvides["src/svg/objects/calendar.svg"] = shadow$bridge("src/svg/objects/calendar.svg");
module$shadow_js_shim_module$src$svg$objects$calendar_svg.default = shadow.js.shim.module$src$svg$objects$calendar_svg;
